import type {TypographyProps} from '@mui/material/Typography';

export const getEmphasizedFontWeight = (variant: TypographyProps['variant']) => {
    return variant === 'micro' || variant === 'subtitle' ? '600' : '500';
};
